<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.product.list') }}
      </h1>

      <div
        v-if="!isDistributorLocked"
        class="card rounded-0 mb-4"
      >
        <form class="card-body">
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.product.distributorRef') }} *
              </label>
              <select
                v-model="criterias.selectedDistributorRef"
                :disabled="isDistributorLocked"
                :class="status(v$.criterias.selectedDistributorRef)"
                name="distributor"
                class="form-control rounded-0 form-select form-select"
                placeholder="$t('label.product.distributorRef')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.product.distributorRef') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedDistributorRef.required.$invalid">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="search()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.products.products.length">
        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>{{ $t('label.product.reference') }}</th>
                <th>{{ $t('label.product.name') }}</th>
                <th>{{ $t('label.product.distributorRef') }}</th>
                <th>{{ $t('label.product.status') }}</th>
                <th>{{ $t('label.product.activationDate') }}</th>
                <th>{{ $t('label.product.deactivationDate') }}</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="product in displayedProducts"
                :key="product.id"
                class="mb-3"
              >
                <td>{{ product.prb1 }}</td>
                <td>{{ product.prb3 }}</td>
                <td>{{ product.prb7 }}</td>
                <td>{{ product.productStatus }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(product.prb4) }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(product.prb6) }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom me-2"
                    @click="showDetails(product)"
                  >
                    {{ $t('button.detail') }}
                  </button>
                  <button
                    v-if="hasPermission('product:create')"
                    type="button"
                    class="btn btn-sm btn-primary font-custom rounded-pill  border me-2"
                    @click="showEdit(product)"
                  >
                    {{ $t('button.edit') }}
                  </button>
                  <button
                    v-if="hasPermission('product:create')"
                    type="button"
                    class="btn btn-sm btn-outline-secondary font-custom rounded-pill  border me-2"
                    @click="showCreate(product)"
                  >
                    {{ $t('button.copy') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.products.products"
          @page-update="displayedProducts = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./ProductList.js"></script>

<style src="./ProductList.scss" scoped lang="scss"></style>
